import { InjectionToken } from '@angular/core';

import { OverlayData } from './overlay.interface';

export const OVERLAY_DATA = new InjectionToken<OverlayData>('OVERLAY_DATA');
